import moment from 'moment';
import locale from 'common/momentLocale';
import { DEFAULT_LOCALE } from 'config/constants';

import * as loginActions from 'login/loginActions';
import * as actions from './langActions';
import { success } from '../app/actions';

function defineMomentLocale(lang) {
  if (lang === 'en') {
    moment.updateLocale('en', locale.en);
  } else if (/pt/g.test(lang)) {
    moment.updateLocale('pt-br', locale.pt);
  } else if (lang === 'es') {
    moment.updateLocale('es', locale.es);
  }
}

defineMomentLocale(DEFAULT_LOCALE);

const initialState = {
  locale: DEFAULT_LOCALE,
};

const langReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SELECT_LANGUAGE:
      defineMomentLocale(action.payload);
      return {
        ...state,
        locale: action.payload,
      };
    case success(loginActions.LOGIN):
    case success(loginActions.AUTH): {
      const { user } = action.payload;
      defineMomentLocale(user ? user.language : 'pt');
      return { ...state, locale: user ? user.language : 'pt'};
    }
    default:
      return state;
  }
};

export default langReducer;
